<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：メッセージボックス
 *
 * 作成者：2022/1/5 ノア）黄
 * 最終修正者：2022/1/5 ノア）黄
 *
 -->
<template>
  <ttiDialog
    :isShow="visible"
    :showHead="showHead"
    :showClose="showClose"
    :title="title"
    :width="width"
    :marginTop="'35vh'"
  >
    <template slot="body">
      <p class="messageBoxBody">
        {{ message }}
      </p>
    </template>
    <template slot="foot">
      <div class="btnContainer">
        <el-button
          class="tti-btn-default tti-btn-001"
          :class="[yesButtonClasses]"
          v-if="showYesButton"
          @click.native="handleAction(actionType.yes)"
          @keydown.enter="handleAction(actionType.yes)"
        >
          {{ yesButtonText }}
        </el-button>
        <el-button
          class="tti-btn-default tti-btn-002"
          :class="[noButtonClasses]"
          v-if="showNoButton"
          @click.native="handleAction(actionType.no)"
          @keydown.enter="handleAction(actionType.no)"
        >
          {{ noButtonText }}
        </el-button>
        <el-button
          class="tti-btn-default tti-btn-002"
          :class="[cancelButtonClasses]"
          v-if="showCancelButton"
          @click.native="handleAction(actionType.cancel)"
          @keydown.enter="handleAction(actionType.cancel)"
        >
          {{ cancelButtonText }}
        </el-button>
      </div>
    </template>
  </ttiDialog>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import TtiDialog from '@/components/TtiDialog.vue'
import { ActionType } from './messageBox'

@Component({
  name: 'messageBox',
  components: {
    TtiDialog
  }
})
export default class MessageBox extends Vue {
  actionType = ActionType
  width = '450px'
  title = ''
  showHead = true
  showClose = false
  showYesButton = true
  showNoButton = true
  showCancelButton = true
  yesButtonText = 'はい'
  noButtonText = 'いいえ'
  cancelButtonText = 'キャンセル'
  yesButtonClass = ''
  noButtonClass = ''
  cancelButtonClass = ''
  message = ''
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  callback = (action: ActionType): void => {
    return
  }
  onClose = (): void => {
    return
  }

  visible = false

  action = ActionType.cancel

  get yesButtonClasses(): string {
    return `${this.yesButtonClass}`
  }

  get noButtonClasses(): string {
    return `${this.noButtonClass}`
  }

  get cancelButtonClasses(): string {
    return `${this.cancelButtonClass}`
  }

  handleAction(action: ActionType): void {
    this.action = action
    this.doClose()
  }

  doClose(): void {
    if (!this.visible) return
    this.visible = false
    this.onClose && this.onClose()
    setTimeout(() => {
      if (this.action) this.callback(this.action)
    })
  }
}
</script>

<style scoped lang="scss">
.btnContainer {
  display: flex;
  justify-content: flex-end;
}

.messageBoxBody {
  white-space: pre-line;
  margin: 26px 2px;
}
</style>
